import React from 'react';
import Avatar from 'components/Avatar';
import Pill from 'components/Pill';
export default function SharedByPill(_ref) {
  var pictureUrl = _ref.pictureUrl,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Pill, {
    iconRenderer: function iconRenderer() {
      return pictureUrl ? /*#__PURE__*/React.createElement(Avatar, {
        scale: 0.7,
        pictureUrl: pictureUrl
      }) : null;
    }
  }, children);
}